import breakpoints from './breakpoints';
import findPos from './findPos';
import getUrlVars from './getUrlVars';
import log from './log';
import validateExists from './validateExists';
import updateStringValues from '../components/value';
import { submitButtonIsDisabled, disableSubmitButton, enableSubmitButton } from '../components/submitButton';

const createWindowFunctions = () => {
  window.isMobile = breakpoints.isMobile;
  window.isDesktop = breakpoints.isDesktop;
  window.isDesktopXL = breakpoints.isDesktopXL;
  window.findPos = findPos;
  window.getUrlVars = getUrlVars;
  window.log = log;
  window.validateExists = validateExists;
  window.updateStringValues = updateStringValues;
  window.submitButtonIsDisabled = submitButtonIsDisabled;
  window.disableSubmitButton = disableSubmitButton;
  window.enableSubmitButton = enableSubmitButton;
};

export default createWindowFunctions;
